  import React, { useState, useEffect } from "react";
  import { useNavigate } from "react-router-dom";
  import Button from "@mui/material/Button";
  import Table from "@mui/material/Table";
  import TableBody from "@mui/material/TableBody";
  import TableCell from "@mui/material/TableCell";
  import TableHead from "@mui/material/TableHead";
  import TableRow from "@mui/material/TableRow";
  import Switch from "@mui/material/Switch";
  import EditIcon from "@mui/icons-material/Edit";
  import DeleteIcon from "@mui/icons-material/Delete";
  import Dialog from "@mui/material/Dialog";
  import DialogActions from "@mui/material/DialogActions";
  import DialogContent from "@mui/material/DialogContent";
  import DialogTitle from "@mui/material/DialogTitle";
  import Tooltip from "@mui/material/Tooltip";
  import AlertIcon from "@mui/icons-material/Warning";
  import IconButton from "@mui/material/IconButton";
  import CloseIcon from "@mui/icons-material/Close";
  import TablePagination from '@mui/material/TablePagination';
  import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

  import Swal from 'sweetalert2';
  import { ToastContainer, toast } from "react-toastify";
  import {
    insertResourcesTable,
    getResourcesDetails,
    deleteResourcesDetails,
    updateResourcesTable,
    disableResourcesDetails,
    get_entity_type,
    getDistrict,
    getBlockByDistrict,
    getVillageByBlock,
    freeze_members,
    get_resources__freeze_details,
  } from "../../api/User";
  import "../Admin/table.css"
  const ManageFacilatorASResourcePerson = ({ designationFacilitator, department }) => {
    const [errors, setErrors] = useState({});
    const userId = sessionStorage.getItem("user_id");
    const [blocks, setBlocks] = useState([]);
    const [villages, setVillages] = useState([]);
    const role_id = sessionStorage.getItem("role_id");
    const gpID = sessionStorage.getItem("gp_data") || "";
    const [otherDepartmentInput, setOtherDepartmentInput] = useState(false);
    const [formData, setFormData] = useState({
      user_id: userId,
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_name: "",
      entity_type: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
      other_department_name: "",
    });
    const [formErrors, setFormErrors] = useState({
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_name: "",
      entity_type: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
      other_department_name: "",

    });
    const [filteredData, setFilteredData] = useState([]);
    const [filterModifyData, setFilteredDataModify] = useState([]);
    const [filteredFreezeData, setFilteredDataFreeze] = useState([]);
    const [token, setToken] = useState(sessionStorage.getItem("token") || "");
    const [EntityTypeErr, setEntityTypeErr] = useState("");
    const [lgdCode, setLgdCode] = useState("");
    const [rows, setRows] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [DepartmentNameErr, setDepartmentNameErr] = useState("");
    const [othersDepartmentInput, setOthersDepartmentInput] = useState(false);
    const [isTableVisible, setIsTableVisible] = useState(true);
    const [isModifyVisible, setIsModifyVisible] = useState(false);
    const [isFreezeVisible, setIsFreezeVisible] = useState(false);
    const [editData, setEditData] = useState({
      user_id: userId,
      designation: "",
      mobile_no: "",
      full_name: "",
      email: "",
      entity_name: "",
      entity_type: "",
      district: "",
      block: "",
      gram_panchayat: "",
      department_name: "",
      otherDepartmentName: "",
    });
    const [othersInput, setOthersInput] = useState(false);
    const [entityTypes, setEntityTypes] = useState([]);
    const [editOthersInput, setEditOthersInput] = useState(false);
    const [editOtherValue, setEditOtherValue] = useState("");
    const [entity, setEntity] = useState("");
    const [districts, setDistricts] = useState([]);
    const [entityName, setEntityName] = useState([]);
    const navigate = useNavigate();
    const [showOtherDesignation, setShowOtherDesignation] = useState(false);
    const [activeButton, setActiveButton] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [modifyPagerPage] = useState(10);
    const [freezePage, setFreezePage] = useState(0);
    const [modifyRowsPerPage, setModifyRowsPerPage] = useState(10);
    const [freezeRowsPerPage, setFreezeRowsPerPage] = useState(10);
    const [modifyPage, setModifyPage] = useState(0);

    const fetchDataFreeze = async (ID) => {
      const data = {
        id: ID,
        role_id: role_id,
        gp_data_id: gpID,
      };
      try {
        const res = await get_resources__freeze_details(token, data);
        console.log(res);
        if (res.status === "success") {
          const freez = res.data.filter((item) => {
            return item.is_active == 1
          })
          // const freez = res.data.filter((item) => {
          //   return item.is_active == 1
          // })
          // setFilteredData(res.data);
          setFilteredDataFreeze(freez);
          // setFilteredDataModify(modify);

        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("An error occurred while fetching data.", { autoClose: 1000 });
      }
    };
    const fetchData = async () => {
      const data = {

        role_id: role_id,
        gp_data_id: gpID,

      };
      try {
        const res = await getResourcesDetails(token, data);
        console.log(res);
        if (res.status === "success") {
          const modify = res.data.filter((item) => {
            return item.is_active == 1 && item.is_freeze == 0
          })
          const freez = res.data.filter((item) => {
            return item.is_active == 1
          })
          setFilteredData(res.data);
          //setFilteredDataFreeze(freez);
          setFilteredDataModify(res.data);

        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("An error occurred while fetching data.", { autoClose: 1000 });
      }
    };

    useEffect(() => {
      handleReset();
      setOthersInput(false);
      setOthersDepartmentInput(false);

      fetchData();
      fetchDataFreeze();

    }, []);
    const validateMobileNo = (mobile_no) => {
      if (!mobile_no) return "Mobile Number is required.";

      if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";

      if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";

      if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";

      return "";
    };

    const validateFullName = (fullName) => {
      if (!fullName) {
        return "Full Name is required.";
      }
      const invalidCharRegex = /[^A-Z\s]/;
      if (invalidCharRegex.test(fullName)) {
        return "Full Name cannot contain numbers or special characters.";
      }
      return "";
    };
    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    const handleChange = (event) => {
      const { name, value } = event.target;

      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: value.trim() ? "" : prevErrors[name],
      }));

      if (name === "mobile_no") {
        const numericValue = value.replace(/\D/g, '').slice(0, 10);
        setFormData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));

        setFormErrors((prevState) => ({
          ...prevState,
          [name]: validateMobileNo(numericValue),
        }));
      } else if (name === "full_name") {
        const uppercaseValue = value.toUpperCase();
        const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');

        setFormData((prevState) => ({
          ...prevState,
          [name]: cleanedValue,
        }));

        setFormErrors((prevState) => ({
          ...prevState,
          [name]: validateFullName(cleanedValue),
        }));
      } else if (name === "email") {
        const lowercaseValue = value.toLowerCase();
        setFormData((prevState) => ({
          ...prevState,
          [name]: lowercaseValue,
        }));

        setFormErrors((prevState) => ({
          ...prevState,
          [name]: validateEmail(lowercaseValue) ? "" : "Invalid email format",
        }));
      } else if (name === "designation") {
        if (value === "Other") {
          setOthersInput(true);
        } else {
          setOthersInput(false);
          setFormData((prevState) => ({
            ...prevState,
            [name]: value,
            other_designation: "",
          }));
        }
      }
      else if (name === "department_name") {
        if (value === "Other") {
          setOtherDepartmentInput(true);
        } else {
          setOtherDepartmentInput(false);
          setFormData((prevState) => ({
            ...prevState,
            [name]: value,
            other_department_name: "",
          }));
        }
      } else if (name === "entity_type") {
        let updatedEntityName = '';
        if (value === "Village Panchayat") {
          updatedEntityName = entityName.village;
        } else if (value === "Block Panchayat") {
          updatedEntityName = entityName.block;
        } else if (value === "District Panchayat") {
          updatedEntityName = entityName.district;
        }

        setFormData((prevState) => ({
          ...prevState,
          entity_type: value,
          entity_name: updatedEntityName,
          district_name: value === "District Panchayat" ? "" : prevState.district_name,
          block_name: ["Intermediate Panchayat", "Village Panchayat"].includes(value) ? "" : prevState.block_name,
          gram_name: value === "Village Panchayat" ? "" : prevState.gram_name,
        }));

        setEntity(updatedEntityName);
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    };
    const handleDepartmentChange = (e) => {
      console.log(e.target.value);
      setFormData((prevState) => ({
        ...prevState,
        other_department_name: e.target.value,
      }));
    };


    const handleEdit = (ID) => {
      const selectedRecord = filteredData.find(record => record.id === ID);
      if (!selectedRecord) {
        console.error('Record not found');
        return;
      }
      const isOtherDesignation = !designationFacilitator.includes(selectedRecord.designation);
      const isOtherDepartment = !department.includes(selectedRecord.department_name);

      setEditData({
        ...selectedRecord,
        designation: isOtherDesignation ? "Other" : selectedRecord.designation,
        customDesignation: isOtherDesignation ? selectedRecord.designation : "",

        department_name: isOtherDepartment ? "Other" : selectedRecord.department_name,
        otherDepartmentName: isOtherDepartment ? selectedRecord.department_name : "",

        entity_type: selectedRecord.entity_type,
      });
      fetchBlocks(selectedRecord.district_code);
      setVillages([]);
      fetchVillages(selectedRecord.district_code, selectedRecord.block_code);
      setOthersInput(isOtherDesignation);
      setOthersDepartmentInput(isOtherDepartment);

      setOpenEditModal(true);
    };
    const handleEditChange = (event) => {
      const { name, value } = event.target;

      setEditData((prevState) => ({
        ...prevState,
        [name]: value,
      }));

      const formattedValue = name === "email" ? value.trim().toLowerCase() : value;
      setEditData((prevState) => ({
        ...prevState,
        [name]: formattedValue,
      }));
      if (name === "email") {
        const emailValue = formattedValue;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = emailRegex.test(emailValue);

        setErrors((prevState) => ({
          ...prevState,
          email: isValidEmail ? "" : "Invalid email format",
        }));
      }

      if (name === "entity_type") {
        let updatedEntityName = "";
        if (value === "Village Panchayat") {
          updatedEntityName = entityName.village;
        } else if (value === "Block Panchayat") {
          updatedEntityName = entityName.block;
        } else if (value === "District Panchayat") {
          updatedEntityName = entityName.district;
        }

        setEditData((prevState) => {
          let updatedEntityType = value;
          let updatedEntityName = prevState.entity_type;
          if (value === 3) {
            updatedEntityType = "Village Panchayat";
          }

          return {
            ...prevState,
            entity_type: updatedEntityType,
            entity_name: updatedEntityName,
            district: value === "District Panchayat" ? "" : prevState.district,
            block: ["Block Panchayat", "Village Panchayat"].includes(value) ? "" : prevState.block,
            gram_panchayat: value === "Village Panchayat" ? "" : prevState.gram_panchayat,
          };
        });

        setDistricts([]);
        setBlocks([]);
        setVillages([]);
        fetchDistricts();
      }

      if (name === "district_code") {
        setEditData((prevState) => ({
          ...prevState,
          district_code: value,
          block_code: "",
          gram_panchayat_code: "",
        }));

        setBlocks([]);
        setVillages([]);
        fetchBlocks(value);
      }

      if (name === "block_code") {
        const district_code = editData.district_code;

        setEditData((prevState) => ({
          ...prevState,
          block_code: value,
          gram_panchayat_code: "",
        }));

        setVillages([]);
        fetchVillages(district_code, value);

        if (value) {
          setErrors((prevState) => ({
            ...prevState,
            block_code: "",
          }));
        }
      }

      if (name === "gram_panchayat_code") {
        setEditData((prevState) => ({
          ...prevState,
          gram_panchayat_code: value,
        }));

        if (value) {
          setErrors((prevState) => ({
            ...prevState,
            gram_panchayat_code: "",
          }));
        }
      }

      if (name === "mobile_no") {
        const numericValue = value.replace(/\D/g, "").slice(0, 10);
        setEditData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));
        setErrors((prevState) => ({
          ...prevState,
          [name]: validateMobileNo(numericValue),
        }));
      }

      if (name === "full_name") {
        const uppercaseValue = value.toUpperCase();
        const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, "");
        setEditData((prevState) => ({
          ...prevState,
          [name]: cleanedValue,
        }));
        setErrors((prevState) => ({
          ...prevState,
          [name]: cleanedValue.trim() ? "" : "Full Name is required.",
        }));
      }

      if (name === "designation") {
        const isOther = value === "Other";
        setEditData((prevState) => ({
          ...prevState,
          [name]: value,
          customDesignation: isOther ? prevState.customDesignation || "" : "",
        }));
        setOthersInput(isOther);
        setErrors((prevState) => ({
          ...prevState,
          designation: value ? "" : "Designation is required.",
        }));
      }

      if (name === "otherDesignation") {
        const cleanedValue = value.trim();
        const firstChar = cleanedValue.charAt(0);
        const isValid = cleanedValue.length > 0 && /^[A-Za-z]/.test(firstChar);

        setEditData((prevState) => ({
          ...prevState,
          customDesignation: value,
        }));
        setErrors((prevState) => ({
          ...prevState,
          otherDesignation: isValid ? "" : "Other Designation must start with a letter and cannot be empty.",
        }));
      }

      if (name === "department_name") {
        const isOther = value === "Other";
        setEditData((prevState) => ({
          ...prevState,
          [name]: value,
          otherDepartmentName: isOther ? prevState.otherDepartmentName || "" : "",
        }));
        setOthersDepartmentInput(isOther);
        setErrors((prevState) => ({
          ...prevState,
          department_name: value ? "" : "Department Name is required.",
        }));
      }

      if (name === "otherDepartmentName") {
        setEditData((prevState) => ({
          ...prevState,
          otherDepartmentName: value,
        }));
        setErrors((prevState) => ({
          ...prevState,
          otherDepartmentName: value.trim() ? "" : "Other Department Name is required.",
        }));
      }
    };

    const handleEditSubmit = async (event) => {
      event.preventDefault();
      const cleanedCustomDesignation = editData.customDesignation ? editData.customDesignation.trim() : "";
      const errors = {
        full_name: editData.full_name.trim() ? "" : "Full Name is required.",
        mobile_no: validateMobileNo(editData.mobile_no),
        email: editData.email ? "" : "Email ID is required.",
        entity_type: editData.entity_type ? "" : "Entity Type is required.",
        designation: editData.designation ? "" : "Designation is required.",
        district: editData.district_code ? "" : "District is required.",
        block_code: editData.block_code ? "" : "Block is required.",
        gram_panchayat_code: editData.gram_panchayat_code ? "" : "Gram Panchayat is required.",
        otherDesignation: editData.designation === "Other" && !editData.customDesignation
          ? "Other Designation is required."
          : "",
        otherDepartmentName: editData.department_name === "Other" && !editData.otherDepartmentName
          ? "Other Department Name is required."
          : ""
      };

      setErrors(errors);
      const hasErrors = Object.values(errors).some((error) => error !== "");

      if (hasErrors) {
        return;
      }

      try {
        const dataToSubmit = {
          ...editData,
          designation: editData.designation === "Other" ? editData.customDesignation : editData.designation,
          department_name: editData.department_name === "Other" ? editData.otherDepartmentName : editData.department_name,
        };

        const res = await updateResourcesTable(token, dataToSubmit);

        if (res.status === "success") {
          toast.success(res.message, { autoClose: 1000 });
          fetchData();
          handleReset();
          setOpenEditModal(false);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error updating record:", error);
        toast.error("An error occurred while updating the record.", { autoClose: 1000 });
      }

      setOthersInput(false);
      setOthersDepartmentInput(false);
    };

    const handleReset = () => {
      setFormData({
        user_id: userId,
        designation: "",
        mobile_no: "",
        full_name: "",
        email: "",
        entity_type: "",
        other_designation: "",
        district: "",
        block: "",
        gram_panchayat: "",
        department_name: "",
      });
      setOtherDepartmentInput(false);
      setFormErrors({
        designation: "",
        mobile_no: "",
        full_name: "",
        email: "",
        entity_type: "",
        district: "",
        block: "",
        gram_panchayat: "",
        department_name: "",


      });
      setEntity("")
      setOthersInput(false);
      setOthersDepartmentInput(false);

    };
    const handleDelete = (ID) => {
      const selectedRecord = filteredData.find(record => record.id === ID);
      if (!selectedRecord) {
        console.error('Record not found');
        return;
      }
      setDeleteIndex(ID);
      Swal.fire({
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this record?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleConfirmDelete(ID);
        }
      });
    };
    const handleConfirmDelete = async (idToDelete) => {
      try {
        await deleteResourcesDetails(token, idToDelete);
        const updatedData = filteredData.filter(record => record.id !== idToDelete);
        setFilteredData(updatedData);

        toast.success("Deleted successfully", { autoClose: 1000 });
        fetchData();
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.", { autoClose: 1000 });
      }
    };

    const handleCancelDelete = () => {
      setOpenDialog(false);
    };

    const handleDisableButton = async (is_active, ID) => {
      const newIsActive = is_active === 1 ? 0 : is_active;

      const data = {
        id: ID
      };

      try {
        const res = await disableResourcesDetails(token, data);
        if (res.status === "success") {

          setRows((prevRows) =>
            prevRows.map((row) =>
              row.id === ID ? { ...row, is_active: newIsActive } : row
            )
          );
          toast.success("Deactivate successfully", { autoClose: 1000 });
          fetchData();


        } else {
          toast.error("An error occurred while updating the item.", { autoClose: 1000 });
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.", { autoClose: 1000 });
      }
    };
    const handleDesignationChange = (e) => {
      console.log(e.target.value);
      formData.designation = e.target.value
    };
    const handleEditDesignationChange = (e) => {
      const newValue = e.target.value;
      console.log(newValue);
      setEditData((prevState) => ({
        ...prevState,
        designation: newValue,
      }));
      setEditOtherValue(newValue);

    };

    useEffect(() => {
      const fetchEntityTypes = async () => {
        try {
          const res = await get_entity_type(token);
          if (res.status === "success") {
            setEntityTypes(res.data);
          } else {
            toast.error(res.message, { autoClose: 1000 });
          }
        } catch (error) {
          console.error("Error fetching entity types:", error);
          toast.error("An error occurred while fetching entity types.", { autoClose: 1000 });
        }
      };

      fetchEntityTypes();
    }, [token]);

    const fetchDistricts = async () => {
      try {
        const res = await getDistrict(token);
        if (res.status === "success") {
          setDistricts(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching districts:", error);
        toast.error("An error occurred while fetching districts.", { autoClose: 1000 });
      }
    };
    useEffect(() => {
      fetchDistricts();
    }, []);



    const fetchBlocks = async (district_code) => {
      try {
        const res = await getBlockByDistrict(token, district_code);
        if (res.status === "success") {
          setBlocks(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching blocks:", error);
        toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
      }
    };

    const fetchVillages = async (district_code, block_code) => {
      try {
        const res = await getVillageByBlock(token, district_code, block_code);
        if (res.status === "success") {
          setVillages(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching villages:", error);
        toast.error("An error occurred while fetching villages.", { autoClose: 1000 });
      }
    };
    const handleView = () => {
      setIsTableVisible(true);
      setIsModifyVisible(false);
      setIsFreezeVisible(false);

    };
    const handleModify = () => {
      setIsTableVisible(false);
      setIsModifyVisible(true);
      setIsFreezeVisible(false);

    };
    const handleFreeze = () => {
      setIsTableVisible(false);
      setIsModifyVisible(false);
      setIsFreezeVisible(true);
    };
    const handleConfirmFreeze = async (is_freeze, ID) => {
      const actionText = is_freeze === 1 ? "unfreeze" : "freeze";
      const result = await Swal.fire({
        title: 'Confirm Action',
        text: `Are you sure you want to ${actionText} this record?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${actionText} it!`,
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        const newIsFreeze = is_freeze === 1 ? 0 : 1;
        const data = {
          id: ID,
          type: "resource",
          role_id: role_id,
        };

        try {
          const res = await freeze_members(token, data);
          if (res.status === "success") {
            const updatedRow = { ...rows.find(row => row.id === ID), is_freeze: newIsFreeze };

            setRows(prevRows =>
              prevRows.map(row =>
                row.id === ID ? updatedRow : row
              )
            );
            toast.success("Data freezed successfully", { autoClose: 1000 });
            fetchData();
            fetchDataFreeze(ID);
          } else {
            toast.error("An error occurred while updating the item.", { autoClose: 1000 });
          }
        } catch (error) {
          console.error("Error during freeze operation:", error);
          toast.error("An error occurred. Please try again.", { autoClose: 1000 });
        }
      }
    };

    const handleButtonClick = (buttonName) => {
      setActiveButton(buttonName);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const handleFreezePageChange = (event, newPage) => {
      setFreezePage(newPage);
    };
    const handleFreezeRowsPerPageChange = (event) => {
      setFreezeRowsPerPage(parseInt(event.target.value, 10));
      setFreezePage(0);
    };
    const paginatedFreezeData = filteredFreezeData.slice(
      freezePage * freezeRowsPerPage,
      freezePage * freezeRowsPerPage + freezeRowsPerPage
    );
    const handleModifyPageChange = (event, newPage) => {
      setModifyPage(newPage);
    };
    const handleModifyRowsPerPageChange = (event) => {
      setModifyRowsPerPage(parseInt(event.target.value, 10));
      setModifyPage(0);
    };
    const paginatedModifyData = filterModifyData.slice(
      modifyPage * modifyRowsPerPage,
      modifyPage * modifyRowsPerPage + modifyRowsPerPage
    );
    return (
      <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>
      <div className="container-fluid" style={{ height: "91vh" }}>
        <div style={{ backgroundColor: '#FFFFFF', padding: '16px', marginTop: "-17px", }}>
          <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>
            Facilitator As Resource Person
          </h2>
        </div>

        <div className="d-flex justify-content-end">
          <div className="col-md-2 row mt-2">
            <Button
              variant="contained"
              onClick={() => {
                handleView();
                handleButtonClick('view');
              }}
              sx={{
                width: "70%",
                backgroundColor: activeButton === 'view' ? "#5E63C7" : "#4763E430", // Active color when inactive
                color: activeButton === 'view' ? "#ffffff" : "#4763E4", // White text when active
                "&:hover": {
                  backgroundColor: "#4763E4", // Hover background color
                  color: "#ffffff", // Hover text color
                },
              }}
            >
              {isTableVisible ? 'View' : 'View'}
            </Button>
          </div>
          <div className="col-md-2 row mt-2">
            <Button
              onClick={() => {
                handleModify();
                handleButtonClick('modify');
              }}
              variant="contained"
              type="submit"
              sx={{
                width: "70%",
                backgroundColor: activeButton === 'modify' ? "#5E63C7" : "#4763E430", // Inactive color when active
                color: activeButton === 'modify' ? "#ffffff" : "#4763E4", // White text when active
                "&:hover": {
                  backgroundColor: "#4763E4", // Hover background color
                  color: "#ffffff", // Hover text color
                },
              }}
            >
              {isModifyVisible ? 'Modify' : 'Modify'}
            </Button>
          </div>
          <div className="col-md-2 row mt-2">
            <Button
              onClick={() => {
                handleFreeze();
                handleButtonClick('freeze');
              }}
              variant="contained"
              type="submit"
              sx={{
                width: "70%",
                backgroundColor: activeButton === 'freeze' ? "#5E63C7" : "#4763E430", // Inactive color when active
                color: activeButton === 'freeze' ? "#ffffff" : "#4763E4", // White text when active
                "&:hover": {
                  backgroundColor: "#4763E4", // Hover background color
                  color: "#ffffff", // Hover text color
                },
              }}
            >
              {isFreezeVisible ? 'Freeze' : 'Freeze'}
            </Button>
          </div>
        </div>

        <div>
          {isTableVisible && (
            <div >
              <h4 style={{ fontWeight: "bold", margin: "16px" }}>View Resources</h4>
              <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
              <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '20px' }}>
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        SR NO.
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DEPARTMENT NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        OFFICER NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DESIGNATION
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        MOBILE NUMBER
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        EMAIL ID
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        ENTITY TYPE
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DISTRICT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        BLOCK
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        GRAM PANCHAYAT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        STATUS
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: row.is_active === 0 ? "#ffcccc" : "none",
                          }}
                        >
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                            {row.department_name}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.full_name}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                            {row.customDesignation || row.designation}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.mobile_no}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.email}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.entity_type}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.district || '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.block || '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.gram_panchayat_name !== null && row.gram_panchayat_name !== undefined ? row.gram_panchayat_name : '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              {row.is_freeze == 0 ? (
                                <Tooltip title="Unfreezed" arrow>
                                  <span
                                    variant="contained"
                                    color="secondary"
                                    // onClick={() => handleDisableButton(row.id)}
                                    style={{
                                      width: '100px',
                                      height: '40px',
                                      marginRight: '8px',
                                      color: 'purple',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    UNFREEZED
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Freezed" arrow>
                                  <span
                                    variant="contained"
                                    color="primary"
                                    // onClick={() => handleDisableButton(row.id)}
                                    style={{
                                      width: '100px',
                                      height: '40px',
                                      color: "blue",
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    FREEZED
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={11} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                          Data Not Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          )}
        </div>

        <div>
          {isModifyVisible && (
            <div >
              <h4 style={{ fontWeight: "bold", margin: "16px" }}>Modify Resources</h4>
              <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
              <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '20px' }}>
                <Table aria-label="simple table" >
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "rgb(232 233 246)",
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        SR NO.
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DEPARTMENT NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        OFFICER NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DESIGNATION
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        MOBILE NUMBER
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        EMAIL ID
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        ENTITY TYPE
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DISTRICT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        BLOCK
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        GRAM PANCHAYAT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filterModifyData.length > 0 ? (
                      paginatedModifyData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: row.is_active === 0 ? "#ffcccc" : "none",
                          }}
                        >
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                            {row.department_name}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.full_name}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                            {row.customDesignation || row.designation}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.mobile_no}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.email}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.entity_type}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.district || '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.block || '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.gram_panchayat_name !== null && row.gram_panchayat_name !== undefined ? row.gram_panchayat_name : '----------'}
                          </TableCell>
                          <TableCell
                            style={{ whiteSpace: "nowrap", textAlign: "center" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Tooltip title="Edit" arrow>
                                <Button
                                  onClick={() => handleEdit(row.id)}
                                  size="small"
                                  sx={{ color: "blue", minWidth: "auto", marginRight: "5px" }}
                                >
                                  <EditIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                              <Tooltip title="Delete" arrow>
                                <Button
                                  onClick={() => handleDelete(row.id)}
                                  size="small"
                                  sx={{ color: "red", minWidth: "auto" }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                              <Tooltip title={row.is_active ? "Deactivate" : "Activate"} arrow>
                                <Switch
                                  disabled={row.is_active === 0}
                                  checked={row.is_active === 1}
                                  onChange={() => handleDisableButton(row.is_active, row.id)}
                                  color="default"
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "green",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                      backgroundColor: "green",
                                    },
                                    "& .MuiSwitch-track": {
                                      backgroundColor: "red",
                                    },
                                  }}
                                />
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={11} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                          Data Not Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={filterModifyData.length}
                  rowsPerPage={modifyRowsPerPage}
                  page={modifyPage}
                  onPageChange={handleModifyPageChange}
                  onRowsPerPageChange={handleModifyRowsPerPageChange}
                />
              </div>
            </div>
          )}
        </div>

        <div>
          {isFreezeVisible && (
            <div >
              <h4 style={{ fontWeight: "bold", margin: "16px" }}>Freeze Resources</h4>
              <hr style={{ margin: '20px 0', border: '2px solid #ddd' }} />
              <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '20px' }}>
                <Table aria-label="simple table">
                  <TableHead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#3235761A",
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        SR NO.
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DEPARTMENT NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        OFFICER NAME
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DESIGNATION
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        MOBILE NUMBER
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        EMAIL ID
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        ENTITY TYPE
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        DISTRICT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        BLOCK
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        GRAM PANCHAYAT
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                        Freeze
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredFreezeData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={11} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                          Data Not Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      paginatedFreezeData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          style={{
                            backgroundColor: row.is_active === 0 ? "#ffcccc" : "none",
                          }}
                        >
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                            {row.department_name}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.full_name}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                            {row.customDesignation || row.designation}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.mobile_no}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.email}
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                            {row.entity_type}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.district || '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.block || '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                            {row.gram_panchayat_name !== null && row.gram_panchayat_name !== undefined ? row.gram_panchayat_name : '----------'}
                          </TableCell>
                          <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <Tooltip title={row.is_active === 1 ? "Unfreeze" : "Freeze"} arrow>
                                <Button
                                  variant="contained"
                                  color={row.is_active === 1 ? "secondary" : "primary"}
                                  onClick={() => handleConfirmFreeze(row.is_freeze, row.id, index)}
                                  style={{
                                    width: '100px',
                                    height: '40px',
                                    marginRight: '8px',
                                  }}
                                >
                                  Freeze
                                </Button>
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          )}
        </div>

        <Dialog
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: "bold" }}>
            Edit Record
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpenEditModal(false)}
              aria-label="close"
              style={{ position: "absolute", right: 15, top: 7 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <form onSubmit={handleEditSubmit}>
              <div className="row g-3">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label htmlFor="department_name" className="form-label mt-3" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      Department Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={`form-select ${errors.department_name ? "is-invalid" : ""}`}
                      name="department_name"
                      id="editDepartmentName"
                      value={editData.department_name || ""}
                      onChange={handleEditChange}
                      style={{ height: "56px" }}
                      // disabled={editData?.is_active == 0 ? true : false}
                      disabled={editData?.is_active === 0 || editData?.is_active === 1}


                    >
                      <option value="" disabled>Select Department Name</option>
                      {department.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                      {!department.includes(editData.department_name) && (
                        <option value={editData.department_name}>Other</option>
                      )}
                    </select>
                    {errors.department_name && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {errors.department_name}
                      </p>
                    )}
                  </div>
                  {othersDepartmentInput && (
                    <div className="col-md-4">
                      <label
                        htmlFor="otherDepartmentName"
                        className="form-label"
                        style={{ fontSize: "0.9rem", fontWeight: "800" }}
                      >
                        Other Department Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.otherDepartmentName ? "is-invalid" : ""}`}
                        name="otherDepartmentName"
                        id="otherDepartmentName"
                        placeholder="Enter Other Department"
                        value={editData.otherDepartmentName || ""}
                        onChange={handleEditChange}
                        style={{ height: "56px" }}
                        disabled={!othersDepartmentInput || editData?.is_active == 0 ? true : false}

                      />
                      {errors.otherDepartmentName && (
                        <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                          {errors.otherDepartmentName}
                        </p>
                      )}
                    </div>
                  )}

                  <div className="col-md-4">
                    <label htmlFor="editFullName" className="form-label mt-3" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      Officer Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                      name="full_name"
                      id="editFullName"
                      value={editData?.full_name || ""}
                      onChange={handleEditChange}
                      placeholder="Enter the Full Name"
                      style={{ height: "56px" }}
                      disabled={editData?.is_active == 0 ? true : false}

                    />
                    {errors.full_name && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {errors.full_name}
                      </p>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="editMobileNo" className="form-label mt-3" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      Mobile No <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                      name="mobile_no"
                      id="editMobileNo"
                      value={editData?.mobile_no || ""}
                      onChange={handleEditChange}
                      placeholder="Enter the Mobile No"
                      style={{ height: "56px" }}
                      disabled={editData?.is_active == 0 ? true : false}

                    />
                    {errors.mobile_no && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {errors.mobile_no}
                      </p>
                    )}
                  </div>

                </div>
                <div className="col-md-4">
                  <label htmlFor="editEmail" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                    Email ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    name="email"
                    id="editEmail"
                    value={editData?.email || ""}
                    onChange={handleEditChange}
                    placeholder="Enter the Email ID"
                    style={{ height: "56px" }}
                    disabled={editData?.is_active == 0 ? true : false}

                  />
                  {errors.email && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.email}
                    </p>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="entity_code" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                    Entity Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className={`form-control ${formErrors.entity_code ? "is-invalid" : ""}`}
                    name="entity_code"
                    id="entity_code"
                    value={editData.entity_code || ""}
                    onChange={handleEditChange}
                    style={{ height: "56px" }}
                    disabled


                  >
                    <option value="" disabled>
                      Select Entity Type
                    </option>
                    {entityTypes.map((item, index) => (
                      <option key={index} value={item.entity_code}> {item.entity_name}{item.localbody_type_code} </option>
                    ))}
                  </select>
                  {formErrors.entity_code && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {formErrors.entity_code}
                    </p>
                  )}
                </div>

                {(editData.entity_code == 1 || editData.entity_code == 2 || editData.entity_code == 3) && (
                  <div className="col-md-4">
                    <label htmlFor="district_code" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      District Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={`form-select ${formErrors.district_code ? "is-invalid" : ""}`}
                      name="district_code"
                      id="district_code"
                      value={editData.district_code || ""}
                      onChange={handleEditChange}
                      style={{ height: "56px" }}
                      disabled={editData?.is_active == 0 ? true : false}


                    >
                      <option value="" disabled>
                        Select District Name
                      </option>
                      {districts?.map((district, index) => (
                        <option key={index} value={district.district_code}>
                          {district.district}
                        </option>
                      ))}
                    </select>
                    {formErrors.district_code && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {formErrors.district_code}
                      </p>
                    )}
                  </div>
                )}

                {(editData.entity_code == 2 || editData.entity_code == 3) && (
                  <div className="col-md-4">
                    <label htmlFor="block_code" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      Block Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={`form-select ${errors.block_code ? "is-invalid" : ""}`}
                      name="block_code"
                      id="block_code"
                      value={editData.block_code || ""}
                      onChange={handleEditChange}
                      style={{ height: "56px" }}
                      disabled={editData?.is_active == 0 ? true : false}
                    >
                      <option value="">
                        Select Block Name
                      </option>
                      {blocks?.map((block, index) => (
                        <option key={index} value={block.block_code}>
                          {block.block}
                        </option>
                      ))}
                    </select>
                    {errors.block_code && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {errors.block_code}
                      </p>
                    )}
                  </div>
                )}
                {editData.entity_code == 3 && (
                  <div className="col-md-4">
                    <label htmlFor="gram_panchayat_code" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      Gram Panchayat Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={`form-select ${errors.gram_panchayat_code ? "is-invalid" : ""}`}
                      name="gram_panchayat_code"
                      id="gram_panchayat_code"
                      value={editData.gram_panchayat_code || ""}
                      onChange={handleEditChange}
                      style={{ height: "56px" }}
                      disabled={editData?.is_active == 0 ? true : false}
                    >
                      <option value="">
                        Select Gram Panchayat Name
                      </option>
                      {villages?.map((village, index) => (
                        <option key={index} value={village.gram_panchayat_code}>
                          {village.gram_panchayat}
                        </option>
                      ))}
                    </select>
                    {errors.gram_panchayat_code && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {errors.gram_panchayat_code}
                      </p>
                    )}
                  </div>
                )}

                <div className="col-md-4">
                  <label htmlFor="designation" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                    Designation <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className={`form-select ${errors.designation ? "is-invalid" : ""}`}
                    name="designation"
                    id="editDesignation"
                    value={editData?.designation || ""}
                    onChange={handleEditChange}
                    style={{ height: "56px" }}
                    disabled={editData?.is_active == 0 ? true : false}


                  >
                    <option value="" disabled>Select Designation</option>
                    {designationFacilitator.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}

                  </select>
                  {errors.designation && (
                    <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                      {errors.designation}
                    </p>
                  )}
                </div>

                {editData?.designation === "Other" && (
                  <div className="col-md-4">
                    <label
                      htmlFor="otherDesignation"
                      className="form-label"
                      style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                    >
                      Other Designation <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.otherDesignation ? "is-invalid" : ""}`}
                      name="otherDesignation"
                      id="otherDesignation"
                      value={editData?.customDesignation || ""}
                      placeholder="Enter Other Designation"
                      onChange={handleEditChange}
                      style={{ height: "56px" }}
                      disabled={editData?.is_active == 0 ? true : false}


                    />
                    {errors.otherDesignation && (
                      <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                        {errors.otherDesignation}
                      </p>
                    )}
                  </div>
                )}

                <div className="d-flex justify-content-end mt-3">
                  <Button
                    variant="contained"
                    onClick={() => setOpenEditModal(false)}
                    style={{
                      marginRight: "10px",
                      backgroundColor: "#323576",
                      color: "#ffffff",
                      width: "12%",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    style={{
                      backgroundColor: "#323576",
                      color: "#ffffff",
                      width: "12%",
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog open={openDialog} onClose={handleCancelDelete}>
          <DialogTitle>
            <AlertIcon style={{ color: "red", marginRight: "8px" }} />
            Confirm Delete
          </DialogTitle>
          <DialogContent>
            Are you sure you want to delete this record?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelDelete} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <ToastContainer />
      </div>
      </>
    );
  };
  export default ManageFacilatorASResourcePerson;